(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var sel = '.aev__section, .aev__vipcard, .aev__wallet, .aev__trust, .aev__faq details, .acol__card, .dbd-tour__row, .a404__art';
  var els = Array.prototype.slice.call(document.querySelectorAll(sel));
  if (!els.length) return;
  els.forEach(function (el, i) {
    el.classList.add('reveal');
    el.style.transitionDelay = Math.min(i % 8, 6) * 40 + 'ms';
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('reveal--in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  els.forEach(function (el) { io.observe(el); });
})();

/* sticky ADD TO CART: skrýt když je footer ve viewportu (nepřekrývat) */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var footer = document.querySelector('.shopify-section-group-footer-group');
  var stickies = Array.prototype.slice.call(document.querySelectorAll('.aev__sticky, .dbd-sticky'));
  if (!footer || !stickies.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      stickies.forEach(function (s) { s.classList.toggle('sticky-hidden', e.isIntersecting); });
    });
  }, { threshold: 0 });
  io.observe(footer);
})();

/* my-orders: override fixed bg to absolute so footer shows */
(function () {
  if (!document.querySelector('.orders-page')) return;
  var s = document.createElement('style');
  s.textContent = '.orders-page__bg-wrap{position:absolute!important}.orders-page__overlay{position:absolute!important}';
  (document.body || document.head).appendChild(s);
})();

/* cart: force body/html black */
(function () {
  if (!document.querySelector('.cart-page, [data-template="cart"]')) return;
  var s = document.createElement('style');
  s.textContent = 'html,body{background:#0a0a0a!important;background-color:#0a0a0a!important}';
  (document.body || document.head).appendChild(s);
})();

/* aev sticky bar: black background */
(function () {
  var s = document.createElement('style');
  s.textContent = '.aev__sticky{background:#0a0a0a!important;border-top:1px solid #262626!important}.aev__sticky-info{background:#0a0a0a!important}';
  (document.body || document.head).appendChild(s);
})();

/* header cart icon: always white */
(function () {
  var s = document.createElement('style');
  s.textContent = '.header-actions__cart-icon,header cart-icon,header cart-icon svg{color:#fff!important}';
  (document.body || document.head).appendChild(s);
})();
